export default __webpack_public_path__ + "static/media/mobile_beehive_report_uk.9b702634.png";